<template>
  <div class="view pa24">
    <el-table
        :data="tableData"
        style="width: 100%;margin-bottom: 20px;"
        row-key="id"
        border
        lazy>
      <el-table-column
          prop="label"
          align="center"
          label="标识类型"
      />
      <el-table-column
          prop="rule"
          align="center"
          label="编码规则"
      >

        <template slot-scope="scope">
          <el-radio-group v-model="scope.row.rule">
            <el-radio :label="0">数字、字母组合</el-radio>
            <el-radio :label="1">纯数字</el-radio>
          </el-radio-group>
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          prop="length">
        <template slot="header">
          <span>编码长度</span>
          <el-tooltip class="item" effect="dark" content="字母+数字不可设置编码长度，纯数字可设置编码长度，长度需≥10" placement="right">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <el-input-number :disabled="!scope.row.rule || scope.row.rule==0"  :min="10" v-model="scope.row.length" placeholder="请输入编码长度"></el-input-number>
        </template>
      </el-table-column>

      <el-table-column
          prop="hasIncode"
          align="center"
          label="是否生成内码"
      >
        <template slot-scope="scope">
          <el-radio-group v-model="scope.row.hasIncode">
            <el-radio :label="false">否</el-radio>
            <el-radio :label="true">是</el-radio>
          </el-radio-group>
        </template>
      </el-table-column>
      <el-table-column
          prop="inLength"
          align="center"
          label="内码长度"
      >
        <template slot-scope="scope">
          <el-input-number :disabled="!scope.row.hasIncode"   :min="15" :max="30" v-model="scope.row.inLength" placeholder="请输入内码长度"></el-input-number>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: center">
      <el-button type="primary" @click="changeItem" >保存</el-button>
    </div>
  </div>
</template>

<script>

import { changeHandleType,fetchGetCustomCountByType,saveHandleRule } from '@/api/customPage'
import FangYuan from "@/pages/customPage/module/FangYuan.vue";

export default {
  name: "handleType",
  data() {
    return {
      tableData: [
        {
          id: '',
          type:1,
          label: '宣传物料（海报、彩页、手册、手提袋、纸巾包、钥匙扣等）',
          rule: 0,
          length: 10,
          hasIncode:false,
          inLength: 0
        },
        {
          id: '',
          type: 2,
          label: '产品',
          rule: 0,
          length: 10,
          hasIncode:false,
          inLength: 0
        },
        {
          id: '',
          type: 3,
          label: '箱标',
          rule: 0,
          length: 10,
          hasIncode:false,
          inLength: 0
        },
        {
          id: '',
          type: 4,
          label: '证书',
          rule: 0,
          length: 10,
          hasIncode:false,
          inLength: 0
        },
        {
          id: '',
          type: 5,
          label: '盒标',
          rule: 0,
          length: 10,
          hasIncode:false,
          inLength: 0
        },
        {
          id: '',
          type: 6,
          label: '套标',
          rule: 0,
          length: 10,
          hasIncode: false,
          inLength: 0
        },
      ],
    };
  },
  computed: {
  },
  watch:{

  },
  created(){
    this.initData()
  },
  methods:{
    initData(){
      const row = this.tableData;
      let params= {
        companyId: JSON.parse(localStorage.getItem('info')).companyId,
        type: 0
      }
      for (let i=0; i<row.length; i++){
        params.type= row[i].type
        fetchGetCustomCountByType(params).then(res => {
          row[i].id=res.data.id
          row[i].rule = res.data.rule
          row[i].length = res.data.length
          row[i].hasIncode=res.data.hasIncode
          row[i].inLength = res.data.inLength
        })
      }
    },
    changeItem(row){
      let params ={
        list:this.tableData
      }
      saveHandleRule(params).then(res => {
        this.$message({
          message: '操作成功',
          type: 'success'
        });
      })
    }
  }
};
</script>

<style scoped lang='scss'>

</style>
